

export function myPersonalitySave(pointEI, pointSN, pointTF, pointJP, callback) {
	return {
    type: 'MY_PERSONALITY_SAVE',
		payload: {
			pointEI: pointEI,
			pointSN: pointSN,
			pointTF: pointTF,
			pointJP: pointJP,
		},
		callback: callback,
	}
}

export function myPersonalityDel() {
	return {
    type: 'MY_PERSONALITY_DEL',
	}
}
